var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNightMode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "night-mode 1",
    clipPath: "url(#clip0_1594_461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.604 10.7101C16.4447 10.5779 16.2202 10.5581 16.0402 10.6603C15.8647 10.7599 15.6817 10.8493 15.4963 10.9261C14.9045 11.1713 14.2826 11.2956 13.648 11.2956C11.6844 11.2956 9.93013 10.1234 9.17871 8.30928C8.68445 7.11603 8.68445 5.80175 9.17871 4.60853C9.67297 3.41531 10.6023 2.48595 11.7954 1.99172C11.9816 1.91469 12.1742 1.84855 12.3679 1.79516C12.5676 1.74018 12.7123 1.56742 12.7315 1.36126C12.7507 1.1551 12.6404 0.958574 12.4544 0.867631C11.2937 0.29999 10.0005 0 8.7144 0C7.59854 0 6.50579 0.218244 5.4665 0.648689C3.36939 1.51738 1.73606 3.15071 0.867401 5.24782C-0.00129203 7.34493 -0.00129203 9.6548 0.867401 11.7519C1.52326 13.3353 2.62481 14.6671 4.05294 15.6034C5.44658 16.5171 7.06101 17 8.7217 17C9.83789 17 10.931 16.7817 11.9706 16.351C14.2209 15.4189 15.9656 13.5615 16.7571 11.2551C16.8243 11.0592 16.7634 10.8422 16.604 10.7101ZM11.5893 15.4307C10.6712 15.811 9.70637 16.0039 8.72167 16.0039C5.67525 16.0039 2.95349 14.1852 1.78763 11.3707C1.0208 9.5194 1.0208 7.4803 1.78763 5.62899C2.55445 3.77769 3.99636 2.33584 5.84767 1.56898C6.76551 1.18884 7.73002 0.996094 8.7144 0.996094C9.44759 0.996094 10.1836 1.10663 10.8891 1.31996C8.28113 2.71658 7.10292 5.90076 8.25845 8.69042C8.70852 9.77703 9.46442 10.6909 10.4444 11.3335C11.4006 11.9603 12.5084 12.2916 13.648 12.2916C14.2207 12.2916 14.7845 12.2079 15.3306 12.0422C14.5173 13.5594 13.2 14.7636 11.5893 15.4307Z",
    fill: "#292929"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1594_461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightMode);
export default __webpack_public_path__ + "static/media/night-mode.fd020d68c59bae97742c835edb4b0199.svg";
export { ForwardRef as ReactComponent };